// extracted by mini-css-extract-plugin
export default {"container":"content-module--container--2Sdl-"};